export default {
    unionOrgs: [
        { name: '四川在线', href: 'https://www.scol.com.cn/' },
        { name: '四川网络广播电视台', href: 'http://www.sctv.com/' },
        { name: '封面新闻网', href: 'http://www.thecover.cn/' },
        { name: '四川新闻网', href: 'http://www.newssc.org/' },
        { name: '中国西部网', href: 'http://www.cnxibu.com/' },
        { name: '成都全搜索', href: 'http://www.chengdu.cn/' },
        { name: '第四城', href: 'http://www.4c.cn' },
        { name: '成都吃喝玩乐网', href: 'https://www.52ch.net/' },
        { name: '最成都', href: 'http://www.chengtu.com/' },
        { name: '乐山新闻网', href: 'http://www.leshan.cn/' },
        { name: '乐山网络电视', href: 'http://www.leshantv.net/' },
        { name: '广元新闻网', href: 'http://www.gyxww.cn/' },
        { name: '大话利州网', href: 'http://www.dzsm.com/' },
        { name: '苍溪在线', href: 'http://www.cangxi.ccoo.cn/' },
        { name: '巴中传媒网', href: 'http://www.bznews.org/' },
        { name: '巴中新闻网', href: 'http://bz.newssc.org/' },
        { name: '巴中网', href: 'http://www.bzgd.com/' },
        { name: '内江新闻网', href: 'http://www.scnjnews.com' },
        { name: '自贡网', href: 'http://www.zgm.cn/' },
        { name: '荣县网', href: 'http://www.rongxianwang.net/' },
        { name: '富顺在线', href: 'http://www.0813fs.com/' },
        { name: '南充新闻网', href: 'http://www.cnncw.cn/' },
        { name: '南充宣传网信网', href: 'http://www.ncwxw.gov.cn/' },
        { name: '南充零距离', href: 'http://www.0817ch.com' },
        { name: '攀枝花新闻网', href: 'http://www.pzhnews.org/' },
        { name: '达州新闻网', href: 'http://www.dzxw.net/' },
        { name: '秦巴网', href: 'http://www.qinb.net/' },
        { name: '达州日报网', href: 'http://www.dzrbs.com/' },
        { name: '眉山网', href: 'http://www.mshw.net/' },
        { name: '德阳传媒网', href: 'https://scdytv.com/' },
        { name: '中国绵阳新闻网', href: 'http://www.myrb.net/' },
        { name: '迈尚网', href: 'http://www.myntv.cn/' },
        { name: '西蜀网', href: 'http://www.xishu365.com/' },
        { name: '北纬网', href: 'https://www.beiww.com/' },
        { name: '雅安网络电视', href: 'http://www.yatv.tv/' },
        { name: '雅安论坛', href: 'https://www.yaanbbs.net/' },
        { name: '遂宁新闻网', href: 'http://www.snxw.com/' },
        { name: '遂宁传媒网', href: 'http://www.scsntv.com/' },
        { name: '宜宾新闻网', href: 'http://www.ybxww.com/' },
        { name: '宜宾金江网', href: 'http://www.jj831.com/news/Headlines/' },
        { name: '资阳九曲河门户网', href: 'http://www.jiuquhe.com/' },
        { name: '网上武胜', href: 'http://www.wsxc.gov.cn/' },
        { name: '广安新闻网', href: 'http://www.gatv.com.cn/' },
        { name: '泸州新闻网', href: 'http://www.lzep.cn' },
        { name: '泸州网', href: 'http://www.weblz.com.cn' },
        { name: '大听网', href: 'http://www.luzhoubs.com' },
        { name: '泸县新闻网', href: 'http://lxxcb.cn/' },
        { name: '阿坝新闻网', href: 'http://www.aba-news.com.cn/' },
        { name: '中国阿坝州', href: 'http://www.abazhou.gov.cn/' },
        { name: '凉山新闻网', href: 'http://www.ls666.com/' },
        { name: '彝州新闻网', href: 'http://www.lszxc.cn/' },
        { name: '无限凉山（凉山州广播电视台网站）', href: 'http://www.lsiptv.cn' },
    ],
    unionDeps: [
        '省纪委监委',
        '省法院',
        '省检察院',
        '省委宣传部',
        '省委政法委',
        '省委网信办',
        '省发展改革委',
        '经济和信息化厅',
        '教育厅',
        '科技厅',
        '公安厅',
        '财政厅',
        '人力资源社会保障厅',
        '生态环境厅',
        '住房城乡建设厅',
        '交通运输厅',
        '商务厅',
        '文化和旅游厅',
        '省卫生健康委',
        '应急厅',
        '省市场监督管理局',
        '省广电局',
        '省社科院',
        '省药监局',
        '安全厅',
        '省通信管理局',
        '省气象局',
        '人行成都分行',
        '四川银保监局',
        '四川证监局',
        '省科协'
    ],
    unionLinks: [
        { name: '中国网信网', href: 'http://www.cac.gov.cn/' },
        { name: '中央网信办违法和不良信息举报中心', href: 'https://www.12377.cn/' },
        { name: '中国互联网联合辟谣平台', href: 'https://www.piyao.org.cn/' },
    ],
    unionLinksType7: [
        { name: '中国网信网', href: 'http://www.cac.gov.cn/' },
        { name: '中央网信办违法和不良信息举报中心', href: 'https://www.12377.cn/' },
        { name: '中国互联网联合辟谣平台', href: 'https://www.piyao.org.cn/' },
        { name: '四川互联网举报辟谣平台', href: '/' },
    ],
    scpiyaoOrgCn: {
        beianNumber: '3',
        showPoliceBeian: false, // 是否展示川公网安备
    },
    piyaoWeb: {
        beianNumber: '1',
    }
}